/**
 * Project type discriminator — mirrors `projects_v2.project_type` on the backend.
 *
 * Deliberately a leaf module with no imports of its own: it is pulled in by both the
 * project form and the create page, and must never participate in an import cycle.
 */
export const PROJECT_TYPE_TRANSPORTATION = 'transportation';
export const PROJECT_TYPE_WAREHOUSING = 'warehousing';

export const PROJECT_TYPE_OPTIONS = [
	{ value: PROJECT_TYPE_TRANSPORTATION, label: 'Transportation' },
	{ value: PROJECT_TYPE_WAREHOUSING, label: 'Warehousing' },
];

/**
 * Helper copy shown beside the Project Type selector so the user knows what the
 * choice changes before they commit to it (it is locked once the project exists).
 */
export const PROJECT_TYPE_DESCRIPTIONS = {
	[PROJECT_TYPE_TRANSPORTATION]:
		'Transportation projects capture node information used to build routes and trips.',
	[PROJECT_TYPE_WAREHOUSING]:
		'Warehousing projects capture the business model and revenue terms instead of node information. Costs are managed in the Warehousing module.',
};

export const isWarehousingProject = (projectType) => projectType === PROJECT_TYPE_WAREHOUSING;
